import React from 'react';
import { Form, Icon, Input, Button, Spin, Row, Col } from 'antd';
import { connect } from 'react-redux';
import { Redirect, withRouter, Link } from 'react-router-dom';
import * as actions from '../../store/actions/auth';
import { withTranslation } from 'react-i18next';
import './style.css';

const FormItem = Form.Item;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;


class NormalLoginForm extends React.Component {
    state = {
        message: '',
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                // this.props.onAuth(values.userName, values.password);
                this.props.onAuth(values.email, values.password);
                // this.props.history.push('/');
            }
        });
    }

    render() {
        const { t } = this.props;
        // let errorMessage = null;

        // let verifyMessage = null;
        if (this.props.location.state !== undefined && this.props.location.state.message !== undefined) {
            this.state.message = (
                <p>{this.props.location.state.message}</p>
            )
        }

        if (this.props.error) {
            this.state.message = (
                <p>{t('auth.login.login_failed', "Username and password didn't matched.")}</p>
            );
        }

        let message = null;
        if (this.state.message) {
            message = this.state.message;
        }

        const { getFieldDecorator } = this.props.form;

        if (localStorage.getItem('token') === null || localStorage.getItem('token') === undefined) {
            return (
                <Row>
                    <Col md={12}>
                        <div className="login-page-background-image">

                        </div>
                    </Col>
                    <Col md={12} style={{ height: '100vh' }}>
                        <div className="login-wrap">
                            <img src="/static/nerisit-logo-final-light.png" className='login-logo-img'></img>
                            <p className='pStyle' style={{ textAlign: 'center' }}>{t('auth.login.login_text', "Login to your dashboard")}</p>
                            {
                                this.props.loading ?

                                    <Spin indicator={antIcon} style={{ width: '100%', margin: 'auto' }} />

                                    :

                                    <div>
                                        <p style={{ textAlign: 'center' }}>{message}</p>
                                        <Form onSubmit={this.handleSubmit} className="login-form">

                                            {/* <FormItem>
                                                {getFieldDecorator('userName', {
                                                    rules: [{ required: true, message: 'Please input your username!' }],
                                                })(
                                                    <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Username" />
                                                )}
                                            </FormItem> */}

                                            <FormItem>
                                                {getFieldDecorator('email', {
                                                    rules: [{
                                                        type: 'email', message: t('auth.login.email_invalid', "The input is not valid Email!"),
                                                    }, {
                                                        required: true, message: t('auth.login.email_required', "Please input your email!")
                                                    }],
                                                })(
                                                    <Input prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder={t('auth.login.email', "Email")} />
                                                )}
                                            </FormItem>

                                            <FormItem>
                                                {getFieldDecorator('password', {
                                                    rules: [{ required: true, message: t('auth.login.password_required', "Please input your Password!") }],
                                                })(
                                                    <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder={t('auth.login.password', "Password")} />
                                                )}
                                            </FormItem>

                                            <FormItem>
                                                <Link
                                                    className='login-form-forgot'
                                                    // style={{ marginRight: '10px' }}
                                                    to='/password_reset/'> {t('auth.login.password_reset', "Forgot your password?")}
                                                </Link>
                                                <Button type="primary" htmlType="submit" className="login-form-button">
                                                    {t('auth.login.login', "Login")}
                                                </Button>
                                            </FormItem>
                                        </Form>
                                    </div>
                            }
                        </div>

                    </Col>
                </Row>
            );
        } else {
            return (<Redirect to="/" />);
        }
    }
}

const WrappedNormalLoginForm = Form.create()(NormalLoginForm);

const mapStateToProps = (state) => {
    return {
        loading: state.loading,
        error: state.error
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onAuth: (email, password) => dispatch(actions.authLogin(email, password))
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(WrappedNormalLoginForm)));


// WEBPACK FOOTER //
// ./src/containers/Auth/Login.js